import axios from 'axios';

const baseUrl = `${process.env.VUE_APP_API_BASEURL}/Users`;
const headers = { 'Content-Type': 'application/json' };

export default {
  setAuthToken(token) {
    if (token?.length > 0) {
      headers['Authorization'] = `Bearer ${token}`;
    } else {
      delete headers['Authorization'];
    }
  },
  getAuthHeader() {
    return headers['Authorization'];
  },
  postLogin(username, password) {
    const url = `${baseUrl}/login`;
    return new Promise((resolve, reject) => {
      return (
        axios
          .post(url, { username, password }, { headers })
          // get data
          .then((resp) => {
            resolve(resp.data);
          })
          .catch((error) => {
            reject(error);
          })
      );
    });
  },
  renewToken() {
    const url = `${baseUrl}/renew-token`;
    return new Promise((resolve, reject) => {
      return (
        axios
          .get(url, { headers })
          // get data
          .then((resp) => {
            resolve(resp.data);
          })
          .catch((error) => {
            reject(error);
          })
      );
    });
  },
  getMyTask() {
    const url = `${baseUrl}/my-task`;
    return new Promise((resolve, reject) => {
      return (
        axios
          .get(url, { headers })
          // get data
          .then((resp) => {
            resolve(resp.data);
          })
          .catch((error) => {
            reject(error);
          })
      );
    });
  },
  getUsers() {
    const url = `${baseUrl}`;
    return new Promise((resolve, reject) => {
      return (
        axios
          .get(url, { headers })
          // get data
          .then((resp) => {
            resolve(resp.data);
          })
          .catch((error) => {
            reject(error);
          })
      );
    });
  },
  isAuthorized(user) {
    if (user?.token?.length > 0) {
      const expDate = new Date(user.expiry);
      const nowDate = new Date();
      if (expDate.getTime() > nowDate.getTime()) {
        return true;
      }
    }
    return false;
  },
};
